
const messages = {
    en: {
       delivery: {
          orderState: { 
            name: 'OrderState',
            title: 'OrderState management',
            subtitle: 'View, search, create, edit and delete OrderState',
            creating: 'Creating OrderState',
            editing: 'Editing OrderState',
            deleting: 'Deleting OrderState',
            showing: 'Showing OrderState',
            menu: 'OrderState',
            labels: {
                state: 'State',
                takeAwayMessage: 'Take Away Message',
                deliveryMessage: 'Delivery Message'
            },
          
          }
       }
    },
    es: {
       delivery: {
          orderState: { 
            name: 'OrderState',
            title: 'Administración de OrderState',
            subtitle: 'Ver, buscar, crear, editar, y borrar OrderState',
            creating: 'Creando OrderState',
            editing: 'Modificando OrderState',
            deleting: 'Eliminando OrderState',
            showing: 'Detalles de OrderState',
            menu: 'OrderState',
            labels: {
                state: 'Estado',
                takeAwayMessage: 'Mensaje Take Away',
                deliveryMessage: 'Mensaje Delivery'
            },
          
          }
       }
    },
    pt: {
       delivery: {
          orderState: { 
            name: 'OrderState',
            title: 'Administração de OrderState',
            subtitle: 'Ver, buscar, criar, editar e usar OrderState',
            creating: 'Criando OrderState',
            editing: 'Edição OrderState',
            deleting: 'Apagando OrderState',
            showing: 'Detalhes do OrderState',
            menu: 'OrderState',
            labels: {
                state: 'State',
                takeAwayMessage: 'Take Away Message',
                deliveryMessage: 'Delivery Message'
            },
          
          }
       }
    }
}

export default messages
    